<template>
  <FormulateInput
    v-bind="$attrs"
    v-on="$listeners"
    v-model="localValue"
    :type="type"
    :name="name"
    :label="label"
    :help="help"
    :placeholder="placeholder"
    :validation="validation"
    :error-behavior="errorBehavior"
    :value="localValue"
    @input="updateLocalValue"
    :disabled="isDisabled"
  />
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInput',
  mixins: [useReactiveModelMixin('value')],
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    validation: {
      type: [String, Object],
      default: ''
    },
    errorBehavior: {
      type: String,
      default: 'blur'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.$root.$on('clearForm', () => {
      this.localValue = null
    })
  },
  methods: {
    updateLocalValue (newValue) {
      this.localValue = newValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/inputs/NxInput.vue